import React from 'react';
import { useTranslation } from 'react-i18next';
import CapabilityDisclosure from '@components/capabilities/CapabilityDisclosure';
import type { CapabilityStatus } from '@hooks/useCapabilities';
import type { DrbfmCapability } from '@services/settings.service';

interface DrbfmLimitsPanelProps {
  status: CapabilityStatus;
  drbfm?: DrbfmCapability;
  onRetry: () => void;
}

/** The `Field(max_length=...)` bounds in `api/routes/drbfm.py`, shown before the user writes. */
const DrbfmLimitsPanel: React.FC<DrbfmLimitsPanelProps> = ({ status, drbfm, onRetry }) => {
  const { t } = useTranslation();

  return (
    <CapabilityDisclosure
      status={status}
      hasValues={Boolean(drbfm)}
      titleKey="drbfm.limitsTitle"
      onRetry={onRetry}
    >
      {drbfm && (
        <>
          <li>{t('drbfm.limitsClaim', { count: drbfm.claimMaxLength })}</li>
          <li>{t('drbfm.limitsEvidence', { count: drbfm.evidenceMaxLength })}</li>
          <li>{t('drbfm.limitsCausalClaims', { count: drbfm.maxCausalClaims })}</li>
          <li>{t('drbfm.limitsInstruction', { count: drbfm.instructionMaxLength })}</li>
        </>
      )}
    </CapabilityDisclosure>
  );
};

export default DrbfmLimitsPanel;
